import React from 'react';
import { motion } from 'framer-motion';
import { FileText, Scale, Gavel, AlertCircle } from 'lucide-react';

const TermsAndConditions = () => {
    return (
        <div className="min-h-screen bg-white dark:bg-[#030014] pt-32 pb-20">
            <div className="container mx-auto px-6 max-w-4xl">
                {/* Header Section */}
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    className="text-center mb-16"
                >
                    <div className="inline-flex items-center justify-center w-16 h-16 bg-primary/10 rounded-2xl text-primary mb-6">
                        <Scale size={32} />
                    </div>
                    <h1 className="text-4xl md:text-6xl font-black text-slate-900 dark:text-white mb-6">
                        Terms & <span className="text-gradient">Conditions</span>
                    </h1>
                    <p className="text-slate-500 dark:text-slate-400 text-lg">
                        Last updated: February 10, 2024
                    </p>
                </motion.div>

                {/* Content Section */}
                <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ delay: 0.2 }}
                    className="space-y-10"
                >
                    {/* Section 1 */}
                    <div className="bg-slate-50 dark:bg-white/5 p-8 rounded-[2.5rem] border border-slate-100 dark:border-white/5">
                        <div className="flex items-center gap-4 mb-6">
                            <div className="w-10 h-10 bg-primary/20 rounded-xl flex items-center justify-center text-primary">
                                <FileText size={20} />
                            </div>
                            <h2 className="text-2xl font-bold text-slate-900 dark:text-white">Agreement to Terms</h2>
                        </div>
                        <p className="text-slate-600 dark:text-slate-400 leading-relaxed">
                            By accessing or using the MehareTech Solutions website, you agree to be bound by these Terms and Conditions. If you disagree with any part of the terms, then you may not access the service.
                        </p>
                    </div>

                    {/* Section 2 */}
                    <div className="space-y-6">
                        <div className="flex items-center gap-4 mb-6">
                            <div className="w-10 h-10 bg-primary/20 rounded-xl flex items-center justify-center text-primary">
                                <Gavel size={20} />
                            </div>
                            <h2 className="text-2xl font-bold text-slate-900 dark:text-white">Intellectual Property</h2>
                        </div>
                        <p className="text-slate-600 dark:text-slate-400 leading-relaxed">
                            The Service and its original content, features, and functionality are and will remain the exclusive property of MehareTech Solutions and its licensors. Our trademarks and trade dress may not be used in connection with any product or service without the prior written consent of MehareTech Solutions.
                        </p>
                    </div>

                    {/* Section 3 */}
                    <div className="bg-slate-50 dark:bg-white/5 p-8 rounded-[2.5rem] border border-slate-100 dark:border-white/5">
                        <div className="flex items-center gap-4 mb-6">
                            <div className="w-10 h-10 bg-primary/20 rounded-xl flex items-center justify-center text-primary">
                                <AlertCircle size={20} />
                            </div>
                            <h2 className="text-2xl font-bold text-slate-900 dark:text-white">Limitation of Liability</h2>
                        </div>
                        <p className="text-slate-600 dark:text-slate-400 leading-relaxed">
                            In no event shall MehareTech Solutions, nor its directors, employees, partners, agents, suppliers, or affiliates, be liable for any indirect, incidental, special, consequential or punitive damages, including without limitation, loss of profits, data, use, goodwill, or other intangible losses.
                        </p>
                    </div>

                    {/* Section 4 */}
                    <div className="space-y-6">
                        <h2 className="text-2xl font-bold text-slate-900 dark:text-white">Termination</h2>
                        <p className="text-slate-600 dark:text-slate-400 leading-relaxed">
                            We may terminate or suspend access to our Service immediately, without prior notice or liability, for any reason whatsoever, including without limitation if you breach the Terms.
                        </p>
                    </div>

                    <footer className="text-center pt-10 border-t border-slate-100 dark:border-white/5">
                        <p className="text-slate-500 dark:text-slate-500 text-sm">
                            For any legal inquiries, please contact us at:<br />
                            <span className="text-primary font-bold">meharetech@gmail.com</span>
                        </p>
                    </footer>
                </motion.div>
            </div>
        </div>
    );
};

export default TermsAndConditions;
